// extracted by mini-css-extract-plugin
export default {"invalid_tag":"InvalidTag_invalid_tag__Lu3dv"};